import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';

export interface MaterialColor extends BaseEntity {
  typeName?: string;
  name: string;
  hexCode: string;
  sortOrder?: number;
}

export interface MaterialColorData {
  materialType: number;
  name: string;
  hexCode: string;
}

const materialColorApi = createCrudApi<
  MaterialColor,
  MaterialColorData,
  MaterialColorData
>('material-color');

export const reorderMaterialColors = (materialTypeId: number, ids: number[]) =>
  materialColorApi.reorder(ids, { materialType: materialTypeId });
export const createMaterialColor = materialColorApi.create;
export const updateMaterialColor = materialColorApi.update;
export const deleteMaterialColor = materialColorApi.delete;
